import { StrapiImageAsset } from "@/components/StrapiImageAsset";
import theme from "@/styles/theme";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import NextLink from "next/link";
import MarkdownContent from "../MarkdownContent";

export const NetworkAboutFeatureCard = ({
  headline,
  text,
  buttontext,
  link,
  image
}) => {
  return (
    <Grid container spacing={3} justifyContent="center">
      <Grid item xs={6}>
        <StrapiImageAsset
          strapiImageObject={image}
          layout="responsive"
          objectFit="contain"
          width={160}
          height={90}
          fixedHeight={true}
        />
      </Grid>
      {headline && (
        <Grid item xs={12}>
          <Typography
            variant="h4"
            textAlign="center"
            sx={{color: theme.palette.common.black}}
          >
            {headline}
          </Typography>
        </Grid>
      )}
      <Grid item xs={12} sx={{ "& p": {textAlign: "center"} }}>
          <MarkdownContent input={text} />
      </Grid>
      <Grid item xs="auto">
        <NextLink href={`${link}`} passHref legacyBehavior>
          <Button variant="outlined" color="secondary">
            {buttontext}
          </Button>
        </NextLink>
      </Grid>
    </Grid>
  );
};
